module.exports = __webpack_public_path__ + "static/media/12.2ddcdf02.png";